import {reducerWithInitialState} from "typescript-fsa-reducers";
import { InitialState, deepCopyThingyState, deepCopyThingyStateAndMerge } from "../typing/types";
import {UserDetailsActions} from "../actions/table_actions";

export default reducerWithInitialState(InitialState)
        .case(UserDetailsActions.resetData, (state,payload) => {
            const deepCopy=deepCopyThingyState(state);
            if (payload.data){
                deepCopy.model.user = payload.data;
               deepCopy.view.loaded = true;
            }
            return deepCopy;
        })
        .case(UserDetailsActions.resetincmandData, (state,payload) => {
            const deepCopy=deepCopyThingyState(state);
            if (payload.data){
                deepCopy.model.mandantenlist = payload.data;
                deepCopy.view.loaded = true;
            }
            return deepCopy;
        })
        .case(UserDetailsActions.resetnotmandData, (state,payload) => {
            const deepCopy=deepCopyThingyState(state);
            if (payload.data){
                deepCopy.model.listmandanten = payload.data;
                deepCopy.view.loaded = true;
            }
            return deepCopy;
        })
        .case(UserDetailsActions.SetUserDetail, (state,payload) => {
            // create a deepcopy of state and update the variables 
            // ONLY UPDATE THE DEPCOPY AND RETURN IT
            const deepCopy=deepCopyThingyState(state);
            const deepCopy2 = deepCopyThingyStateAndMerge(deepCopy, payload);
            return deepCopy2;
        })
        ;

    